import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { variables } from './Variables.js';
export default function TrendingList_Ar2() {
  const jsonUrl = variables.basename_url + 'updates/index/Coinsinsight_HomeAr_TrendingNews.json';
  const [isLoading, setNisLoading] = useState(false);
  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    setNisLoading(true);
    Get_Data();
  }
  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data() {
    JsonArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    setNisLoading(true);
    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        const newArray = [];
        for (let i = 1; i <= 2 && i < response.data.length; i++) {
          newArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split('T')[0],
            news_imagename: response.data[i].image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),
            Category: response.data[i].Category,
          });
        }
        setJsonArray(newArray);  // هنا بتحدث الـ state
      })
  }
  useEffect(() => {
    setNisLoading(true);
    refda();
  }, [])
  return (
    <>
      {JsonArray.map(da =>
        <div key={da.news_title}  >
          <div className="gallery_item p-3">
            <div className="gallery_item_thumb">
              <a href={da.link}>
                <img className='rounded' style={{ maxWidth: '110px', minWidth: '110px', maxHeight: '87px', minHeight: '87px' }} src={da.news_imagename} alt="gallery" />
              </a>
              <div className="icon"></div>
            </div>
            <div className="gallery_item_content mr-3">
              <div className="post-meta  "style={{direction: "ltr",marginLeft:"17px"}}>
                <div className="meta-date">
                  <span>{da.news_date}</span>
                </div>
                <div className="meta-categories">
                  <a >{da.Category}</a>
                </div>
              </div>
              <h4 className="title Arabic-text "><a href={da.link}>{da.news_title}</a></h4>
            </div>
          </div>
        </div>
      )}
    </>
  );
}



